var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-skeleton-field filter-skeleton"},[_c('v-skeleton-loader',{attrs:{"type":"text, chip"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }